(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-gallery-slideshow]');
    if (!root) return;

    const interval = (parseFloat(root.getAttribute('data-interval')) || 5) * 1000;
    const stagger = (parseFloat(root.getAttribute('data-stagger')) || 0.6) * 1000;
    const tiles = root.querySelectorAll('[data-tile]');

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    function hydrate(img) {
      if (img.dataset.src && !img.src) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      }
    }

    function setupTile(tile, tileIdx) {
      const imgs = tile.querySelectorAll('.gls__img');
      if (imgs.length < 2) return null;

      let current = 0;
      let timer = null;

      function next() {
        const prev = current;
        current = (current + 1) % imgs.length;
        hydrate(imgs[current]);
        const peek = imgs[(current + 1) % imgs.length];
        if (peek) hydrate(peek);

        tile.classList.add('is-animating');
        imgs[current].classList.add('is-active');
        setTimeout(function () {
          imgs[prev].classList.remove('is-active');
          tile.classList.remove('is-animating');
        }, 1000);
      }

      function start() {
        if (timer) return;
        const jitter = (Math.random() * 0.4 - 0.2) * stagger;
        const initialDelay = (tileIdx * stagger) + jitter;
        setTimeout(function kickoff() {
          if (!timer) {
            next();
            timer = setInterval(next, interval);
          }
        }, Math.max(0, initialDelay));
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      return { start: start, stop: stop };
    }

    const controllers = [];
    tiles.forEach(function (tile, idx) {
      const ctrl = setupTile(tile, idx);
      if (ctrl) controllers.push({ tile: tile, ctrl: ctrl });
    });

    if (controllers.length === 0) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const found = controllers.find(function (c) { return c.tile === entry.target; });
          if (!found) return;
          if (entry.isIntersecting) {
            found.ctrl.start();
          } else {
            found.ctrl.stop();
          }
        });
      }, { rootMargin: '200px' });

      controllers.forEach(function (c) { io.observe(c.tile); });
    } else {
      controllers.forEach(function (c) { c.ctrl.start(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-mega-slideshow]');
    if (!root) return;
    const slides = root.querySelectorAll('.mss__slide');
    const dots = root.querySelectorAll('.mss__dot');
    if (slides.length < 2) return;

    const autoplay = root.getAttribute('data-autoplay') === 'true';
    const interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    let current = 0;
    let timer = null;

    function go(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(current + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const idx = parseInt(dot.getAttribute('data-idx'), 10);
        go(idx);
        start();
      });
    });

    // Swipe / drag navigation (mouse, touch, pen)
    let dragStartX = null;
    let dragStartY = null;
    let dragging = false;
    const SWIPE_THRESHOLD = 50; // pixels horizontal before we count it as a swipe

    root.addEventListener('pointerdown', function (e) {
      // ignore clicks on the nav dots (they have their own handler)
      if (e.target.closest('.mss__dot')) return;
      // ignore clicks on links/buttons inside slides
      if (e.target.closest('a, button')) return;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragging = true;
      stop();
    });

    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      // if vertical movement dominates, abort (let the page scroll)
      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
        dragging = false;
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      const dx = e.clientX - dragStartX;
      dragging = false;
      if (Math.abs(dx) >= SWIPE_THRESHOLD) {
        if (dx < 0) {
          go(current + 1); // swiped left → next slide
        } else {
          go(current - 1); // swiped right → previous slide
        }
      }
      start();
    }

    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    root.addEventListener('pointerleave', endDrag);

    if (autoplay) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
